import { render, staticRenderFns } from "./VersionTitle.vue?vue&type=template&id=1c511d7d&"
import script from "./VersionTitle.vue?vue&type=script&lang=js&"
export * from "./VersionTitle.vue?vue&type=script&lang=js&"
import style0 from "./VersionTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports